import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';

import { AppCustomPreloader } from './app-custom-preloader';
import { PageNotFoundComponent } from "./shared/components/page-not-found/page-not-found.component";
import { LoginCallbackComponent } from './login/login-callback/login-callback.component';
import { AuthGuard } from './auth/auth.guard';
import { UserRoles } from './shared/enums/user-roles.enum';
import { HomeComponent } from './shared/components/home/home.component';


const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home'
  },
  {
    path: 'login',
    component: LoginCallbackComponent,
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: HomeComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { requiredRoles: [UserRoles.ADMIN, UserRoles.LOCALIZATION_MANAGER, UserRoles.PUBLICATION_MANAGER, UserRoles.TECHNICAL_WRITER, UserRoles.ENGINEER, UserRoles.REVIEWER, UserRoles.KCS_READONLY_REVIEWER, UserRoles.CONTENT_REVIEWER] }
  },
  {
    path: 'app',
    loadChildren: () => import('./main-app/main-app.module').then((m) => m.MainAppModule)
  },
  {
    path: '**',
    component: PageNotFoundComponent
  },
];

const routerOptions: ExtraOptions = {
  anchorScrolling: 'enabled',
  scrollPositionRestoration: 'enabled',
  preloadingStrategy: AppCustomPreloader,
  useHash: false
};


@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
  providers: [AppCustomPreloader]
})
export class AppRoutingModule {
  constructor() {}
}
